import { render, staticRenderFns } from "./vModal.vue?vue&type=template&id=0d4129cd&scoped=true&"
import script from "./vModal.vue?vue&type=script&lang=js&"
export * from "./vModal.vue?vue&type=script&lang=js&"
import style0 from "./vModal.vue?vue&type=style&index=0&id=0d4129cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4129cd",
  null
  
)

export default component.exports